/* TODO: FIXME: uncomment this when we figure out which recaptcha we will use
interface IWindowWithGrecaptcha {
  grecaptcha: {
    ready(callback: () => void): Promise<void>,
    execute(siteKey: string, action: { action: string }): Promise<string>,
  }
}

export const protect = async <T>(action: string) => {
  const grecaptcha = (window as unknown as IWindowWithGrecaptcha).grecaptcha
  let token: string
  await grecaptcha.ready(async () => {
    token = await grecaptcha.execute(process.env.RECAPTCHA_SITE_KEY, { action })
  })
  return token!
}
  */

export const protect = async (_action: string) => {
  return 'dummy_recaptcha_token'
}
